import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import LandingConnector from "../Landing/Connector/LandingConnector";
import MachineLayout from "../Layout/MachineLayout";
import XookService from "../Landing/Services/XookService";
import Loader from "../Generic/Loader";
import styled from "styled-components";

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width :	100%;
`;

const MachineRoute = (props) => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	async function getMachines() {
		setLoading(true);
		const response = await XookService.getLinkedKiosks();
		const { data, error } = response;
		if (data) {
			if (!data.linkedKiosks) {
				setError(true);
				return;
			}
			const machineData = data.linkedKiosks.find((item) => item._id === id);
			if (!machineData) {
				navigate("/404", { replace: true });
				return;
			}
			props.setMachineID(machineData);
			setLoading(false);
			setError(false);
		}
		if (error) {
			setError(true);
			setLoading(false);
			// errorNotification(error);
		}
	}

	useEffect(() => {
		if (!props.machineID) {
			getMachines();
		}
	}, []);

	if (props.machineID !== "") {
		return (
			<MachineLayout>
				<Outlet />
			</MachineLayout>
		);
	}

	if(loading) {
		return <Container>
			<Loader />
		</Container>
	}

	if (error) {
		return <Navigate to={"/404"} replace />;
	}
};

export default LandingConnector(MachineRoute);
